import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "WeatherAlert", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("button", {
      id: "google-login",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.googleLogin && _ctx.googleLogin(...args)))
    }, "Google Login")
  ], 64))
}